import { AppThunkAction } from './appThunkAction';
import { RequestStatusId, RequestStatusType } from '../state/requestStatusState';

export function trackStatusForRequest(request: Promise<any>, type: RequestStatusType, id: string | number): AppThunkAction {
	return dispatch => {
		dispatch({type: 'request-status/started', requestType: type, requestId: id});
		
		request.then(() => {
			dispatch({type: 'request-status/completed', requestType: type, requestId: id});
		}, () => {
			dispatch({type: 'request-status/failed', requestType: type, requestId: id});
		});
	}
}

interface RequestStarted {
	type: 'request-status/started';
	requestType: RequestStatusType;
	requestId: RequestStatusId;
}

interface RequestCompleted {
	type: 'request-status/completed';
	requestType: RequestStatusType;
	requestId: RequestStatusId;
}

interface RequestFailed {
    type: 'request-status/failed';
	requestType: RequestStatusType;
	requestId: RequestStatusId;
}

export type RequestStatusActions = RequestStarted | RequestCompleted | RequestFailed;